import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib';
import * as actions from './boarding-pass-issue-hpbp.actions';
import { BoardingPassIssueHpbpState } from './boarding-pass-issue-hpbp.state';

/**
 * boardingPassIssueHpbp initial state
 */
export const boardingPassIssueHpbpInitialState: BoardingPassIssueHpbpState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for BoardingPassIssueHpbp Store
 */
export const boardingPassIssueHpbpReducerFeatures: ReducerTypes<BoardingPassIssueHpbpState, ActionCreator[]>[] = [
  on(actions.setBoardingPassIssueHpbp, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateBoardingPassIssueHpbp, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetBoardingPassIssueHpbp, () => boardingPassIssueHpbpInitialState),

  on(actions.cancelBoardingPassIssueHpbpRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failBoardingPassIssueHpbp, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(actions.setBoardingPassIssueHpbpFromApi, actions.updateBoardingPassIssueHpbpFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * BoardingPassIssueHpbp Store reducer
 */
export const boardingPassIssueHpbpReducer = createReducer(
  boardingPassIssueHpbpInitialState,
  ...boardingPassIssueHpbpReducerFeatures
);
